import React from 'react'
import ModalContainer from 'Components/Common/Modal/ModalContainer'
import FillButton from "Components/Common/components/Button/FillButton";
import BorderedButton from "Components/Common/components/Button/BorderedButton";
import { ModalFooter, ModalHeader } from "react-bootstrap";
import { CANCEL } from './constants';

type CopyModalProps = {
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    listName: string;
    setCopyListName: (name: string) => void;
}

const CopyModal = ({ showModal, closeModal, onConfirm, listName, setCopyListName }: CopyModalProps) => {
    return (
        <ModalContainer
            isOpen={showModal}
            setOpen={closeModal}>
            <ModalHeader>
                <div className="tw-font-bold">
                    Copy List
                </div>
            </ModalHeader>

            <div >
                <label className="tw-m-4 tw-mb-0">
                    List Name
                </label>
                <input className="tw-bg-white tw-border tw-border-[#c9c9cf] tw-rounded tw-w-[90%] tw-m-4 tw-mt-2 tw-h-[36px] tw-pl-[10px]" value={listName}
                    onChange={(e) => { setCopyListName(e.target.value) }}
                />
            </div>

            <ModalFooter>
                <div className="tw-flex tw-max-w-full tw-w-full tw-justify-end tw-items-center tw-space-x-3">
                    <BorderedButton onClick={() => closeModal()}>{CANCEL}</BorderedButton>
                    <FillButton className={`!tw-border-red-500 !tw-cursor-pointer !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`} onClick={() => onConfirm()} disabledClassName="!tw-border-red-200 !tw-bg-red-200">Create</FillButton>
                </div>
            </ModalFooter>
        </ModalContainer>

    )
}

export default CopyModal